import { useQuery } from 'react-query';
import { wgApi } from '../../../../app/src/features/api/wgApi';

interface AnvaFlowsInsurancesResponse {
  items: AnvaFlowsCoverage[];
}
export interface AnvaFlowsCoverage {
  id: string;
  name: string;
}

export const getAnvaFlowsCoverages = async (insurancesIds?: string[]) => {
  const { data, isError } = await wgApi.get<AnvaFlowsInsurancesResponse>(
    `/v1/api/anvaflows/supported-coverages`,
    {
      query: {
        insurance_ids: insurancesIds,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

const getUseAnvaFlowsCoveragesQkey = (insuranceIds?: string[]) => [
  'flow-config',
  'anva',
  'coverages',
  insuranceIds,
];

export const useAnvaFlowsCoverages = (insuranceIds?: string[]) => {
  return useQuery(
    getUseAnvaFlowsCoveragesQkey(insuranceIds),
    () => getAnvaFlowsCoverages(insuranceIds),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: !!insuranceIds,
    },
  );
};
